import { createContext,type Dispatch, type ReactNode, type SetStateAction } from 'react';

import type { EnhancedFilterItemTextT } from '../type';

type FilterTextContextProps = {
  children: ReactNode;
  value: FilterTextContextState;
};

type FilterTextContextState = {
  existingTexts: string[];
  setExistingTexts: Dispatch<SetStateAction<string[]>>;
  updatedTexts: EnhancedFilterItemTextT[];
  setUpdatedTexts: Dispatch<SetStateAction<EnhancedFilterItemTextT[]>>;
};

export const FilterTextContext = createContext<FilterTextContextState>({
  existingTexts: [],
  setExistingTexts: () => {},
  updatedTexts: [],
  setUpdatedTexts: () => {},
});

const FilterTextsProvider = ({ children, value }: FilterTextContextProps) => {
  return (
    <FilterTextContext.Provider value={value}>
      {children}
    </FilterTextContext.Provider>
  );
};

export default FilterTextsProvider;
